module.exports = __webpack_public_path__ + "img/paid.de369c5e.png";